import router from '@/router'
import { isMobile } from 'mobile-device-detect';

const slotStorageNamespace = process.env.VUE_APP_STORAGE_SLOT;

const favorites = JSON.parse(localStorage.getItem(slotStorageNamespace));

const state = {
  favorites: favorites || [],
  in_play: false,
  games: [],
  jackpot: [],
  search: null,
  game_url: null,
  currentCategory: '1',
  currentProvider: 'pragmaticplay',
  categories:[],
  providers : [],
  winners:[],
}
const getters = {
  getInPlay(state){
    return state.in_play;
  },
  getSearch(state){
    return state.search;
  },
  getJackpot(state){
    return state.jackpot;
  },
  getGames(state){
    return state.games;
  },
  getGameUrl(state){
    return state.game_url;
  },
  getCurrentProvider(state){
    return state.currentProvider;
  },
  getCurrentCategory(state){
    return state.currentCategory;
  },
  getCategories(state){
    return state.categories;
  },
  getProviders(state){
    return state.providers;
  },
  getFavorites(state){
    return state.favorites;
  },
  getWinners(state){
    return state.winners;
  },
}
const mutations = {
    setInPlay(state, val){
      return state.in_play = val;
    },
    setSearch(state, val){
      return state.search = val;
    },
    setJackpot(state, val){
      return state.jackpot = val;
    },
    setGames(state, val){
      return state.games = val;
    },
    setGameUrl(state, val){
      return state.game_url = val;
    },
    setCurrentProvider(state, val){
      return state.currentProvider = val;
    },
    setCurrentCategory(state, val){
      return state.currentCategory = val;
    },
    setCategories(state, val){
      return state.categories = val;
    },
    setProviders(state, val){
      return state.providers = val;
    },
    setWinners(state, val){
      return state.winners = val
    },
    addWinners(state, val){
      return state.winners.push({...val})
    },
    setFavorites(state, val){
      localStorage.setItem(slotStorageNamespace, JSON.stringify(val));
      return state.favorites = val;
    },
    totalGames(state){ 
         const result = [];
         
         _.forEach(state.providers,((item,itemKey) => {
          let obj = {
               ...item,
               size: _.size(_.filter(state.games, {'provider': item.provider })),
           }
           result.push({...obj})
         }));
  
         state.providers = result;
    },
}
const actions = {
  initWinners({ commit, dispatch }, payload){
    commit('addWinners', payload)
  },
  initSlot({ commit, state, dispatch }) {
        commit('setInPlay', false);
        commit('setGameUrl', null);
			  return axios.get('games/slot')
          .then((response) => {
          commit('setGames', response.data.games);
          commit('setJackpot', _.first(response.data.jackpot.jackpots));
          commit('setCategories', response.data.categories);
          commit('setProviders', (_.sortBy(response.data.providers_v2, [function (o) { return o.sort; }])));
          let first = _.first(state.providers);
          commit('setCurrentProvider', first.name); 
          commit('totalGames');

          if (router.currentRoute.params.provider) {
            commit('setCurrentProvider', 'pragmaticplay')
            
          }if (router.currentRoute.params.category) {
            commit('setCurrentCategory', router.currentRoute.params.category)
          }
          if(!router.currentRoute.params.provider && !router.currentRoute.params.category) {
            router.replace({ params: { category: state.currentCategory, provider: 'pragmaticplay' }});
          }
          if(router.currentRoute.query.game_id && router.currentRoute.query.mobile) {
            dispatch('runGame', { id: router.currentRoute.query.game_id, device: router.currentRoute.query.mobile });
          }
				})
				.catch((err) => {
				});
  },
  runGameFree({ commit, dispatch }, payload) {
      commit('setInPlay', true);
      router.replace({ query: { game_id: payload.id, mobile: payload.device }});
      axios.get('games/slot/demo', { params:{ game_id : payload.id, mobile: payload.device } })
      .then((response) => {
          if (!response.data.config.is_script && isMobile) {
            location.href = response.data.config.url;
            // var open = window.open(response.data.config.url, '_blank');
            // open
            // if (open == null || typeof(open)=='undefined'){
            //   alert("Oyuna giriş sağlayabilmek için lütfen tarayıcınızda Pop-Up etkinliğine izin veriniz.");
            // }
            dispatch('closeGame');
          } else {
            commit('setGameUrl', response.data);
          }
      })
      .catch((err) => {
      });
  },
  runGame({ commit, dispatch }, payload) {
      commit('setInPlay', true);
      router.replace({ query: { game_id: payload.id, mobile: payload.device }});
      axios.get('games/slot/launch', { params:{ game_id : payload.id, mobile: payload.device } })
      .then((response) => {
          if (!response.data.config.is_script && isMobile) {
            location.href = response.data.config.url;
            // var open = window.open(response.data.config.url, '_blank');
            // open
            // if (open == null || typeof(open)=='undefined'){
            //   alert("Oyuna giriş sağlayabilmek için lütfen tarayıcınızda Pop-Up etkinliğine izin veriniz.");
            // }
            dispatch('closeGame');
          } else {
            commit('setGameUrl', response.data);
          }
      })
      .catch((err) => {
      });
  },
  closeGame({ commit, state }) {
    commit('setInPlay', false);
    commit('setGameUrl', null);
    router.replace({ params: { category: state.currentCategory, provider: state.currentProvider }});
  },
  changeCategory({ commit, state }, [category]) {
    commit('setSearch', null);
    commit('setCurrentCategory', category);
    router.replace({ params: { category: category, provider: state.currentProvider }});
  },
  changeProvider({ commit, state }, [provider]) {
    commit('setSearch', null);
    commit('setCurrentProvider', provider);
    commit('setCurrentCategory', 'all');
    router.replace({ params: { category: state.currentCategory, provider: provider }});
  },
  search({ commit }, payload) {
    commit('setSearch', payload);
  },
  favorite({ getters, commit }, payload)
  {
    if(payload){
      let favorites = getters.getFavorites;
      let index = favorites.indexOf(payload.id);
      if(index > -1)
      {
        favorites.splice(index, 1);
      }
      else
      {
        favorites.push(payload.id);
      }

      commit('setFavorites', favorites)
    }
  }
}

export default {
  namespaced:true,
  state,
  getters,
  mutations,
  actions,
}